// src/lib/theme.client.ts — dark mode: clasa `dark` pe <html> (varianta Tailwind `dark:`),
// preferința în localStorage, default = tema sistemului. Fără FOUC major: init_theme() se
// cheamă la ÎNCĂRCAREA modulului de intrare (app/embed), înainte de montarea UI-ului.

import van from "vanjs-core"

const KEY = "urbanism_theme"

export const is_dark = van.state(false)

function apply(v: boolean): void {
	document.documentElement.classList.toggle("dark", v)
	is_dark.val = v
}

export function init_theme(): void {
	const saved = localStorage.getItem(KEY)
	apply(saved ? saved === "dark" : window.matchMedia("(prefers-color-scheme: dark)").matches)
}

export function toggle_theme(): void {
	const v = !is_dark.val
	localStorage.setItem(KEY, v ? "dark" : "light")
	apply(v)
}

/** Butonul de comutare (folosit în AppHeader + PublicHeader). */
export function ThemeToggle(): HTMLElement {
	const t = van.tags
	return t.button(
		{
			class:
				"px-2 py-1.5 rounded-md text-sm text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer",
			title: "Comută tema (luminos/întunecat)",
			onclick: toggle_theme,
		},
		() => (is_dark.val ? "☀️" : "🌙"),
	)
}
